import { omit } from 'lodash';
import moment from 'moment';
import { textTruncate } from '@/helpers/text_truncate';
export class OrderStatusModel {
    constructor(payload) {
        Object.assign(this, omit(payload, 'app'));
        const { app } = payload;
        this.app = app;
    }
    get customerName() {
        return `${this.order.firstName} ${this.order.lastName}`;
    }
    get truncatedProductName() {
        return textTruncate(this.order.firstItem.productName, 30);
    }
    get formattedPlacedAt() {
        const placedAt = new Date(this.placedAt);
        return moment(placedAt).format('MMM D, Y');
    }
}
